let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aSbz2")).then(() => parcelRequire('9t6IE'));